import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import { OptionsList } from "@babackapp/customer-ui/components/option";
import { RadioGroup } from "@babackapp/customer-ui/components/radio-group";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { EnterIcon } from "@radix-ui/react-icons";
import { ArrowLeft } from "lucide-react";
import { Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import { useReturnModeForm } from "../hooks/use-return-mode-form";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { CarrierOption } from "./return-mode-carrier-option";
import { RetractationOption } from "./return-mode-retractation-option";
import { StoreOption } from "./return-mode-store-option";

export function ReturnMode() {
  const { form, onSubmit, availableReturnModes, selectableStores } = useReturnModeForm();
  const selected = form.watch("returnMode");
  const t = useCustomText();

  return (
    <WidgetPage>
      <Header>
        <HeaderTitle>{t("returnMode.title")}</HeaderTitle>
        <HeaderDescription>
          {t("returnMode.description")}
        </HeaderDescription>
      </Header>

      <OptionsList>
        <Controller
          control={form.control}
          name="returnMode"
          render={({ field }) => (
            <RadioGroup onValueChange={field.onChange} value={field.value}>
              {availableReturnModes.includes("carrier") && (
                <CarrierOption
                  control={form.control as any}
                  selected={selected === "carrier"}
                />
              )}
              {availableReturnModes.includes("store") && (
                <StoreOption
                  control={form.control as any}
                  selected={selected === "store"}
                  selectableStores={selectableStores}
                />
              )}
              {availableReturnModes.includes("retractation") && <RetractationOption />}
            </RadioGroup>
          )}
        />
      </OptionsList>

      <AnimatedButtonRow variants={{}}>
        <AnimatedButtonContainer
          layoutId="line-item-back-button"
          disableVariants={{ exit: true }}
          layout="position"
        >
          <Link to="../summary">
            <Button variant="secondary">
              <ArrowLeft />
              {t("common.back")}
            </Button>
          </Link>
        </AnimatedButtonContainer>
        <AnimatedButtonContainer layoutId="line-item-confirm-button" variants={{}}>
          <Button onClick={onSubmit}>
            <EnterIcon />
            {t("common.confirm")}
          </Button>
        </AnimatedButtonContainer>
      </AnimatedButtonRow>
    </WidgetPage>
  );
}
